export const PUSH_NOTIFICATIONS = {
  SUCCESS: 'Push notification sent successfully.',
  FAILED: 'Error occurred while sending push notification to users.',
} as const;
